import(/* webpackMode: "eager" */ "/alias-labs/app/global-error.tsx")